import React from 'react';
import { useDispatch } from 'react-redux';
import { AssetPermissionsDto, AssetVersionItemDto } from '@api/Api';
import { toggleManageAssetVersionsModal } from '@redux/actions/modalAction';
import './AssetVersionsList.less';

function AssetVersionsList({
  versionsCount = 0,
  versions = [],
  permissions,
  assetId
}: {
  versionsCount?: number;
  versions?: AssetVersionItemDto[];
  permissions?: AssetPermissionsDto;
  assetId?: string;
}) {
  const dispatch = useDispatch();
  return (
    <div style={{ display: 'flex', alignContent: 'center' }}>
      <span
        className="version asset-version-button"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            toggleManageAssetVersionsModal({
              versions: versions || [],
              permissions: permissions || null,
              versionsCount: versionsCount || 0,
              visible: true,
              assetId: assetId || ''
            })
          );
        }}
      >
        v{versionsCount}
      </span>
    </div>
  );
}

export default AssetVersionsList;
